const ua = window.navigator.userAgent;


export const isIE = /MSIE/i.test(ua) || /Trident\//i.test(ua) || /Edge\//i.test(ua);

export const isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

export const isSafariDesktop = window.safari !== undefined;
